import { PageLayout } from '../components/PageLayout';

export function IntegrityPolicy() {
  return (
    <PageLayout
      title="Integrity Policy"
      metaTitle="Integrity Policy - Abrovinc"
      metaDescription="Discover Abrovinc's commitment to ethical business practices, professional standards, and technical excellence in IT consultancy services."
      metaKeywords="integrity policy, business ethics, professional standards, transparency, Abrovinc"
      metaUrl="https://abrovinc.com/integrity-policy"
    >
      <p>
        <strong>Last updated:</strong> {new Date().getFullYear()}
      </p>

      <h2>1. Our Commitment</h2>
      <p>
        At Abrovinc, integrity is at the core of everything we do. We are committed to conducting
        our IT consultancy business with the highest standards of ethical behavior, honesty, and
        transparency.
      </p>

      <h2>2. Professional Standards</h2>
      <p>We adhere to the following professional standards:</p>
      <ul>
        <li>
          <strong>Honesty:</strong> We provide accurate information about our capabilities,
          timelines, and project outcomes
        </li>
        <li>
          <strong>Transparency:</strong> We maintain open communication with clients about project
          progress, challenges, and costs
        </li>
        <li>
          <strong>Competence:</strong> We only take on projects where we have the necessary skills
          and expertise
        </li>
        <li>
          <strong>Confidentiality:</strong> We protect client information and proprietary data with
          the utmost care
        </li>
      </ul>

      <h2>3. Client Relationships</h2>
      <p>We build long-term relationships based on trust and mutual respect. We:</p>
      <ul>
        <li>Listen carefully to client needs and requirements</li>
        <li>Provide honest assessments of technical challenges and solutions</li>
        <li>Deliver on our commitments and communicate proactively about any changes</li>
        <li>Respect client confidentiality and intellectual property</li>
        <li>Avoid conflicts of interest and disclose any potential conflicts</li>
      </ul>

      <h2>4. Technical Excellence</h2>
      <p>We are committed to delivering high-quality technical solutions by:</p>
      <ul>
        <li>Staying current with industry best practices and emerging technologies</li>
        <li>Following secure coding practices and security guidelines</li>
        <li>Implementing scalable and maintainable solutions</li>
        <li>Providing thorough documentation and knowledge transfer</li>
        <li>Testing and validating our work before delivery</li>
      </ul>

      <h2>5. Continuous Improvement</h2>
      <p>We continuously strive to improve our services and processes through:</p>
      <ul>
        <li>Regular learning and professional development</li>
        <li>Seeking feedback from clients and incorporating it into our practices</li>
        <li>Reviewing and updating our methodologies</li>
        <li>Investing in new tools and technologies that benefit our clients</li>
      </ul>

      <h2>6. Reporting Concerns</h2>
      <p>
        If you have any concerns about our integrity practices or wish to report an issue, please
        contact us at:
        <br />
        Email: info@abrovinc.com
        <br />
        Address: Umeå, Sweden
      </p>
    </PageLayout>
  );
}
